import React from "react";

function RKA() {
    return(
        <>
        <div className="container">
            <section id="penggunaan-anggaran" class="py-5 bg-light rounded shadow-sm mt-4 container">
                <div class="section-heading">
                    <img src="https://placehold.co/40x40/007bff/ffffff?text=💰" alt="Ikon Penggunaan Anggaran" />
                    <h3 class="h2 fw-bold text-dark">Realisasi Rencana Kerja dan Anggaran</h3>
                </div>
                <p class="lead text-secondary mb-4">
                    Tabel di bawah ini menunjukkan detail realisasi rencana kerja dan anggaran pada Universitas.
                </p>

                <div class="table-responsive mb-4">
                    <h4 className="h4 fw-bold text-primary border-bottom">Realisasi Pendapatan Anggaran</h4>
                    <button className="btn btn-outline-primary" id="btnUpdate">UPDATE</button>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Uraian</th>
                                <th>Pendapatan</th>
                                <th>Realisasi Pendanaan</th>
                                <th>Sisa Anggaran</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Penerimaan Atas Biaya Kuliah Universitas</td>
                                <td>Rp 5.000.000.000</td>
                                <td>Rp 450.000.000</td>
                                <td>Rp 50.000.000</td>
                            </tr>
                           
                        </tbody>
                    </table>
                </div>

                <div class="table-responsive mb-4">
                    <h4 className="h4 fw-bold text-primary border-bottom">Rincian Pendapatan Anggaran</h4>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Uraian Kegiatan</th>
                                <th>Pendapatan</th>
                                <th>Realisasi</th>
                                <th>Sisa Anggaran</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Penerimaan SPP</td>
                                <td>Rp 500.000.000</td>
                                <td>Rp 450.000.000</td>
                                <td>Rp 50.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Kegiatan UAS</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Kegiatan Praktikum</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Kegiatan Wisuda</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Kegiatan KKN</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Kegiatan Al-Islam</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Semhas, Sempro, dan Kompre</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan PKL, KP, dan PLP</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                            <tr>
                                <td>Penerimaan Kegiatan Mata Kuliah</td>
                                <td>Rp 300.000.000</td>
                                <td>Rp 210.000.000</td>
                                <td>Rp 90.000.000</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

        <div class="text-center mt-5">
            <p class="h4 fw-semibold text-dark mb-4">Visualisasi Realisasi Anggaran</p>
            <div class="row justify-content-center g-3">
                <div class="col-12 col-sm-6 col-lg-3">
                    <div class="bg-info bg-opacity-10 p-4 rounded shadow-sm">
                        <img src="https://placehold.co/80x80/60a5fa/ffffff?text=⚙️" alt="Ikon Operasional" class="mx-auto d-block mb-3" />
                        <p class="fw-bold h5 text-primary">Operasional</p>
                        <p class="text-muted">90% Terpakai</p>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <div class="bg-success bg-opacity-10 p-4 rounded shadow-sm">
                        <img src="https://placehold.co/80x80/34d399/ffffff?text=📦" alt="Ikon Pengadaan" class="mx-auto d-block mb-3" />
                        <p class="fw-bold h5 text-success">Pengadaan</p>
                        <p class="text-muted">70% Terpakai</p>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <div class="bg-purple bg-opacity-10 p-4 rounded shadow-sm">
                        <img src="https://placehold.co/80x80/a78bfa/ffffff?text=👥" alt="Ikon Gaji" class="mx-auto d-block mb-3" />
                        <p class="fw-bold h5 text-purple">Gaji & Tunjangan</p>
                        <p class="text-muted">97.5% Terpakai</p>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <div class="bg-warning bg-opacity-10 p-4 rounded shadow-sm">
                        <img src="https://placehold.co/80x80/fbbf24/ffffff?text=📢" alt="Ikon Pemasaran" class="mx-auto d-block mb-3" />
                        <p class="fw-bold h5 text-warning">Pemasaran</p>
                        <p class="text-muted">53.3% Terpakai</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
        </div>
        </>
    )
}

export default RKA;